import { post, get } from "./utils";

// 获取医院科室页的导航栏
export const getNavigationBarDto = (params?: any) =>
  post("SeoHospitalDepart_getNavigationBarDto", params, "");

// 获取医生相关的导航栏
export const getNavigationBarDtoList = (params?: any) =>
  post("SeoDoctorPage_getNavigationBarDtoList", params, "");
